/* Lithoforma: move the "Get in touch" (.lf-contact) section into the main
   page content wrapper so it sits inside the upper content div, at the
   bottom — rather than as a separate section below it. */
(function () {
  function relocate() {
    var contact = document.querySelector('.lf-contact');
    if (!contact) return;

    var mySection = contact.closest('.shopify-section');
    if (!mySection) return;

    // Find the content wrapper of a preceding section (the main page body).
    var prev = mySection.previousElementSibling;
    var target = null;
    while (prev && !target) {
      if (prev.querySelector) target = prev.querySelector('.section-content-wrapper');
      if (!target) prev = prev.previousElementSibling;
    }

    if (target && !target.contains(contact)) {
      target.appendChild(contact);
      // The original section is now empty; hide it so it leaves no gap.
      mySection.style.display = 'none';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relocate);
  } else {
    relocate();
  }
})();
